export function tagName(n: Element): string;
export function tagName(n: Node): string | null;
export function tagName(n: Node | Element): string | null {
  const tag = (n as Element).tagName;
  if (!tag) {
    return null;
  }

  if (typeof tag === 'object') {
    // If the child of a form element has the name or id "tagName", it overwrites the
    // property with itself as the value
    return 'form';
  }

  return tag.toLowerCase();
}

// Keep in sync with go/src/fs/services/julia/internal/prep/web/resources.go.
const ImageCandidateStrRE = /(\s*(\S+)(\s+(?:\d+w|[\d.]+x)){0,1}\s*[,])/gm;
// Keep in sync with go/src/fs/services/julia/internal/prep/web/resources.go. This is a srcset regex sanitizer with optional descriptors
const ImageCandidateStrREWithDesc =
  /((\s*(\S+)(\s+(?:\d+w|[\d.]+x)){0,1}\s*(\s*\d+\S){0,1}(\s*\d+(.\d*){0,1}\S){0,1}\s*)[,])/gm;
function trimCommaWhitespace(x: string) {
  return x.replace(/^[, ]+|[, ]+$/g, '');
}

export function splitSrcset(srcsetArg: string, flagSrcsetDescriptors: boolean = true): string[] {
  // Split srcset into image candidate strings as defined in
  // http://w3c.github.io/html/semantics-embedded-content.html#element-attrdef-img-srcset
  let srcset = srcsetArg;
  srcset = `${srcset.replace(/\s+/g, ' ')},`;

  const srcSetCandidates = srcset.match(
    flagSrcsetDescriptors ? ImageCandidateStrREWithDesc : ImageCandidateStrRE,
  );

  if (!srcSetCandidates) {
    console.warn(`Couldn't parse srcset '${srcset}'`);
    return [];
  }

  const parts: string[] = [];
  for (const m of srcSetCandidates) {
    parts.push(trimCommaWhitespace(m));
  }

  return parts;
}
